import React, { useState } from 'react';
import Modal from '../../../../../../components/Modal';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { faUserEdit } from '@fortawesome/pro-solid-svg-icons';
import AddCoTeacher from '../../../../../classes/components/addCoteacher';
import Skeleton from 'react-loading-skeleton';
import NoAssignment from '../../../../../../assets/images/NoAssignment.png';

const ViewCoTeachersModal = ({ modalData, onClose, coteachers ,setCoteachers, coTeachersDataLoading, isDistrictManaged }) => { 
  const [addCoteachersModal, setAddCoteachersModal] = useState(false);
  const hasAllowEdit = coteachers?.some(coteacher => coteacher.allowEdit);
  
  return (
    <>
      <Modal
        contentWidth="700px"
        isOpen={modalData}
        titleName='View/Add Co-Teachers'
        titleToolTip='Co-teachers will have access to all of your assignments by default.'
        onClose={() => {onClose();setCoteachers([]);}}
      >
        {!coTeachersDataLoading && coteachers?.length > 0 && <>
          <div className='container collaborators-list'>
            <div className='row'>
              {coteachers.map((item) => (
                <div key={item.id} className='my-2 col-6'>
                  <div className='box-background d-flex align-items-baseline custom-p-tag'>
                    <p className='me-auto'>{item.name}</p>
                    {item.allowEdit && <FontAwesomeIcon icon={faUserEdit} style={{ color: '#82A9E2' }} /> }
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
        }
        {!coTeachersDataLoading && (!coteachers || coteachers?.length==0) &&
          <div className="no-assignments-card">
            <div className="text-center no-assignments-icon">
              <img src={NoAssignment} className="my-4" />
              <p className="mx-5">
                The class does not have any co-teachers, You can add co-teachers by clicking on the <b>Add button</b>
              </p>
            </div>
          </div>
        }
        {coTeachersDataLoading && <>
          <div><Skeleton /></div>
          <div><Skeleton /></div>
          <div><Skeleton /></div>
        </>
        }
        {hasAllowEdit && <div className='d-flex py-4'>
          <FontAwesomeIcon icon={faUserEdit} style={{ color: '#82A9E2' }} /><div>&nbsp;<span>Means co-teacher has class editing rights</span></div>
        </div> }
        
        {!isDistrictManaged &&
          <div className='addcollaborators mt-2'>
            <div className='mt-4'
              onClick={() => setAddCoteachersModal(true)}>
              <FontAwesomeIcon className='box-background' icon={faPlus} style={{ color: '#82A9E2' }} />
              <div>Add/Edit Co-Teachers</div>
            </div>
          </div>
        }
      </Modal>

      {addCoteachersModal && (
        <AddCoTeacher
          isOpen={addCoteachersModal} 
          onClose={()=>setAddCoteachersModal(false)}
          coTeachers={coteachers}
          setCoTeachers={setCoteachers}          
        />)}
    </>
  );
};

ViewCoTeachersModal.propTypes = {
  modalData: PropTypes.bool,
  onClose: PropTypes.func,
  coteachers : PropTypes.array,
  setCoteachers: PropTypes.func,
  coTeachersDataLoading: PropTypes.bool,
  isDistrictManaged: PropTypes.bool
};

export default ViewCoTeachersModal;
